<template>
    <div>
        <div class="ah-container">
            <audit-flow-table type="projectAuditFlowSetting" :setting="auditFlowSettings.projectAuditFlowSetting" @onEdited="onFlowSettingEdited" :editable="isEditable"></audit-flow-table>
            <audit-flow-table type="payoutAuditFlowSetting" :setting="auditFlowSettings.payoutAuditFlowSetting" @onEdited="onFlowSettingEdited" :editable="isEditable"></audit-flow-table>
            <audit-flow-table type="invoiceAuditFlowSetting" :setting="auditFlowSettings.invoiceAuditFlowSetting" @onEdited="onFlowSettingEdited" :editable="isEditable"></audit-flow-table>
        </div>
        <center>
            <el-alert v-if="!isEditable" :closable="false" style="margin: 0 0 20px 0" center>
                <template slot="title">
                    <div>您所購買的方案不包含自訂審核流程</div>
                </template>
            </el-alert>
            <el-button type="" class="primary-action" @click="handlePrev">回上一步</el-button>
            <el-button type="primary" class="primary-action" @click="handleNext">下一步</el-button>
        </center>
    </div>
</template>
<script>
import AuditFlowTable from '@/components/dashboard/Settings/AuditFlowSetting/AuditFlowTable.vue';

export default {
    components: {
        AuditFlowTable,
    },
    data() {
        return {
            currTab: 'payout',
            isLoading: false,
            auditFlowSettings: {
                invoiceAuditFlowSetting: { isEnable: null, settings: [] },
                payoutAuditFlowSetting: { isEnable: null, settings: [] },
                projectAuditFlowSetting: { isEnable: null, settings: [] },
            },
        };
    },
    mounted() {
        this.fetchAuditFlows();
    },
    computed: {
        isEditable() {
            if (this.isSAAdmin || this.isAhooAgent) return true;
            return this.isPayed('S01');
        },
    },
    methods: {
        fetchAuditFlows() {
            this.isLoading = true;

            this.$api({
                url: '/Tool/GetAuditFlowTemplates',
                method: 'GET',
            })
                .then((resp) => {
                    console.log(resp);
                    this.auditFlowSettings = resp.data;

                    if (resp.data.invoiceAuditFlowSetting.settings.length == 0) {
                        this.initAuditFlow();
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        onFlowSettingEdited() {
            this.fetchAuditFlows();
        },
        handlePrev() {
            this.$router.push({ name: 'setup-statement' });
        },
        handleNext() {
            this.$router.push({ name: 'setup-finish' });
        },
    },
};
</script>
<style lang="scss">
.setup-audit-page {
    .enable-switch {
        text-align: center;
        padding-top: 40px;
        padding-bottom: 20px;
    }

    .description {
        max-width: 450px;
        margin: 20px auto 20px auto;
        font-size: 11pt;
        color: #444;
        text-align: center;
    }

    .tabs {
        display: inline-block;
        margin: 0 auto;

        .el-tabs__item {
            font-size: 13pt;
        }
    }
}
</style>
